<template>
  <div id="app">
    <div class="notification-list">
      <div
        v-for="notification in getNotificationList"
        class="notification"
        :class="notification.type ? '--' + notification.type : ''"
        :key="notification.id"
      >
        <h2 class="notification__headline">{{ notification.title }}</h2>
        <p class="notification__text">{{ notification.message }}</p>
        <button
          v-if="notification.confirm"
          class="notification__ok"
          tabindex="0"
          @click="dismissNotification(notification.id)"
        >
          OK
        </button>
      </div>
    </div>
    <template v-if="getIsLoadedState">
      <router-view />
    </template>
    <Loading v-else />
  </div>
</template>

<script>
import DeviceType from './helpers/DeviceType';
import Loading from './pages/Loading.vue';
export default {
  components: { Loading },
  name: 'App',
  mounted() {
    console.log('MOUNTED');
    // Overlay-Bestätigung per Fernbedienung: App.vue hört global in der
    // CAPTURE-Phase, damit es VOR dem seiten-eigenen keyHandler-Mixin greift.
    // Nur aktiv, solange eine confirm-Nachricht sichtbar ist (siehe Guard).
    window.addEventListener('keydown', this.onOverlayKey, true);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onOverlayKey, true);
  },
  methods: {
    callbackShowWindow(context) {
      console.log('WINDOW CONTEXT', context);
    },
    dismissNotification(id) {
      this.$store.dispatch('notification/dismiss', id);
    },
    onOverlayKey(e) {
      // Oberste Nachricht, die eine Bestätigung erfordert.
      const list = this.$store.state.notification.list;
      let target = null;
      for (let i = list.length - 1; i >= 0; i--) {
        if (list[i].confirm) {
          target = list[i];
          break;
        }
      }
      if (!target) return; // keine confirm-Nachricht → Tasten normal durchlassen

      const code = e.keyCode;
      const isEnter =
        code === 13 || e.key === 'Enter' || e.code === 'Enter' || e.code === 'Submit';
      const isBack =
        code === 461 || // LG webOS BACK
        code === 10009 || // Tizen RETURN
        code === 8 || // Backspace (Browser/Dev)
        code === 27 || // Escape
        e.code === 'Backspace' ||
        e.code === 'Escape' ||
        e.code === 'GoBack' ||
        e.code === 'XF86Back';

      if (isEnter || isBack) {
        // Vor dem Seiten-Handler stoppen. Beide liegen auf window, daher reicht
        // stopPropagation NICHT — es braucht stopImmediatePropagation.
        e.preventDefault();
        e.stopImmediatePropagation();
        this.dismissNotification(target.id);
      }
    },
  },

  computed: {
    getNotificationList() {
      return this.$store.state.notification.list;
    },
    getIsLoadedState() {
      return this.$store.state.isLoadedState;
    },
  },
};
</script>

<style>
/* body {
  background-color: lightcyan;
  height: 100vh;
  width: 100vw;
  padding: 0;
  margin: 0;
  overflow: hidden;
} */
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: black; */
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  height: 100vh;
  overflow: hidden;
  position: relative;
  text-align: left;
  width: 100vw;
}

.notification-list {
  display: flex;
  flex-direction: column-reverse;
  position: absolute;
  right: 40px;
  top: 80px;
  z-index: 999;
}

.notification {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 15px;
  border: 5px solid transparent;
  box-sizing: border-box;
  color: rgba(250, 250, 250);
  margin-bottom: 5px;
  min-height: 10vh;
  padding: 20px;
  width: 40vw;
}
.notification__headline {
  margin: 0;
  margin-bottom: 10px;
  font-size: 35px;
  padding: 0;
  letter-spacing: 1px;
}
.notification__text {
  font-size: 27px;
  padding: 0;
  margin: 0;
}

.--error {
  border-color: red;
}
.--socket {
  border-color: yellowgreen;
}
.--info {
  border-color: #3b82f6;
}
.--alarm {
  border-color: #e11d48;
  background: rgba(80, 0, 12, 0.92);
}
.notification__ok {
  margin-top: 16px;
  padding: 10px 32px;
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  background: #3b82f6;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
}
.--alarm .notification__ok {
  background: #e11d48;
}
.notification__ok:focus {
  outline: none;
  border-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue